import React  from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function MuseScreenRenderer({
	screenIndex,
	scanLinePosition,
	faceZoomed,
	showFaceScanLine,
	faceScanLinePosition,
	showLargeS,
	typewriterText,
	fullText,
	screens,
	videoToShow,
	faceScanVideo,
	sizeVideo,
	formFittingVideo,
}: any) {
	const screen = screens[screenIndex];

	// Map screen id to props for each component
	const componentProps: any = {
		body: { scanLinePosition, videoToShow },
		face: {
			faceZoomed,
			showFaceScanLine,
			faceScanLinePosition,
			faceScanVideo,
		},
		sizeFit: { showLargeS, typewriterText, fullText, sizeVideo },
	};

	const hasComponent = !!screen.component;
	const Comp = hasComponent ? screen.component : null;

	let content = null;
	if (hasComponent) {
		content = React.createElement(Comp.type || Comp, componentProps[screen.id] || {});
	} else if (screen.image) {
		content = (
			<video className="h-full w-full object-contain border-none" muted loop autoPlay playsInline preload="auto">
				<source src={formFittingVideo} type="video/mp4" />
			</video>
		);
	}

	return (
		<AnimatePresence mode="wait">
			<motion.div key={screenIndex} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.4 }} className="w-full h-full">
				{content}
			</motion.div>
		</AnimatePresence>
	);
}
